<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Dados Gerais"
      >
        <NxInputDocument
          @update:value="handleInputUpdate('document', $event)"
        />
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)" />
        <NxInput
          name="numProtocolo"
          type="text"
          label="Número do Protocolo:"
          placeholder="Digite o Número do Protocolo:"
          @update:value="handleInputUpdate('numProtocolo', $event, false)"
        ></NxInput>
      </SearchCollapse>

      <SearchCollapse title="Instituição">
        <NxSelectPA @update:value="handleSelectUpdate('paIds', $event)" />
        <NxSelectRegional
          @update:value="handleSelectUpdate('nomeRegional', $event)"
        />
        <NxSelectFuncionario
          :variable="employeeTypes.GERENTE"
          @update:value="handleSelectUpdate('gerenteId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Responsável">
        <NxSelectFuncionario
          :variable="employeeTypes.RESPONSAVEL"
          @update:value="handleSelectUpdate('responsavelId', $event)"
        />
        <NxSelectResponsavelGrupo
          @update:value="handleSelectUpdate('gruposResponsaveisId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Produto">
        <NxSelectProduto
          @update:value="handleSelectUpdate('produtosId', $event)"
        />
        <NxInput
          name="operacao"
          type="text"
          label="Operação:"
          placeholder="Digite o número da operação"
          @update:value="handleInputUpdate('operacao', $event)"
        />
        <NxInputMoneyRange
          @update:InitialValue="
            handleInputUpdate('valorInicial', $event, false)
          "
          @update:FinalValue="handleInputUpdate('valorFinal', $event, false)"
        />
        <NxInputNumberRange
          label="Dias em atraso:"
          @update:InitialValue="handleInputUpdate('diasAtrasoInicio', $event)"
          @update:FinalValue="handleInputUpdate('diasAtrasoFinal', $event)"
        />
      </SearchCollapse>
      <SearchCollapse title="Cobrança">
        <NxSelectQuadro @update:value="handleSelectUpdate('boardId', $event)" />
        <NxSelectRisco
          :riskType="riskTypes[0]"
          @update:value="handleSelectUpdate('riscoBacen', $event)"
        />
        <NxSelectRisco
          :riskType="riskTypes[1]"
          @update:value="handleSelectUpdate('riscoSicoob', $event)"
        />
      </SearchCollapse>
      <SearchCollapse title="Interação">
        <NxInputDateRange
          label="Perí­odo de Referência:"
          @update:InitialValue="
            handleInputDateUpdate('dataInteracaoInicial', $event, false)
          "
          @update:FinalValue="
            handleInputDateUpdate('dataInteracaoFinal', $event, false)
          "
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import {
  NxInputDateRange,
  NxInputDocument,
  NxInputMoneyRange,
  NxInputName,
  NxInputNumberRange
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectFuncionario,
  NxSelectPA,
  NxSelectProduto,
  NxSelectQuadro,
  NxSelectRegional,
  NxSelectResponsavelGrupo,
  NxSelectRisco
} from '@/components/nexum/components/custom-selects/index.js'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import riskTypes from '@/enums/enumRiskTypes.js'

export default {
  name: 'SidebarQuadro',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectRisco,
    NxSelectPA,
    NxSelectRegional,
    NxSelectFuncionario,
    NxSelectResponsavelGrupo,
    NxSelectProduto,
    NxSelectQuadro,
    NxInputDocument,
    NxInputName,
    NxInputMoneyRange,
    NxInputNumberRange,
    NxInputDateRange
  },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        document: null,
        paIds: null,
        nomeRegional: null,
        gerenteId: null,
        responsavelId: null,
        gruposResponsaveisId: null,
        produtosId: null,
        operacao: null,
        valorInicial: null,
        valorFinal: null,
        diasAtrasoInicio: null,
        diasAtrasoFinal: null,
        boardId: null,
        riscoSicoob: null,
        riscoBacen: null,
        dataInteracaoInicial: null,
        dataInteracaoFinal: null,
        numProtocolo: null
      },
      riskTypes: riskTypes,
      employeeTypes: employeeTypes
    }
  },
  methods: {
    submitForm () {
      // TODO: encode the name before sendind it
      // this.form.nome = encodeURIComponent(this.form.nome)
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      this.form[dataPropName] = encodeURIComponent(value)
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map((v) => (v.hasOwnProperty('value') ? v.value : v))
          : selectedValue.hasOwnProperty('value')
            ? selectedValue.value
            : selectedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let parts = inputedValue.split('-')
        let reversed = parts.reverse()
        let newDate = reversed.join('/')
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/cobranca/search/SidebarCobranca.vue